import React from "react";
import PropTypes from "prop-types";
import Page from "../../components/Page";

import UpdateShiftTypeForm from "../../components/forms/UpdateShiftTypeForm";
import ShiftTypeCompaniesList from "../../components/ShiftTypeCompaniesList";

import CenteredPageContentContainer from "../../components/CenteredPageContentContainer";
import PaperContainer from "../../components/PaperContainer";

const UpdateShiftTypePage = (props) => (
  <Page enableGoBack title="Dienstsoort wijzigen">
    <CenteredPageContentContainer>
      <PaperContainer title="Dienstsoort wijzigen">
        <UpdateShiftTypeForm id={props.match.params.id} />
      </PaperContainer>
    </CenteredPageContentContainer>
    <CenteredPageContentContainer>
      <PaperContainer
        title="Tarieven per bedrijf"
        createLink={`/shifttype/${props.match.params.id}/company/create`}
      >
        <ShiftTypeCompaniesList shiftTypeId={props.match.params.id} />
      </PaperContainer>
    </CenteredPageContentContainer>
  </Page>
);

UpdateShiftTypePage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
  }),
};

export default UpdateShiftTypePage;



// WEBPACK FOOTER //
// ./src/pages/ShiftType/UpdateShiftTypePage.js